/**
 * @generated SignedSource<<ffc48cd5595264276f55862fea41c04f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetList_listItemInfo$data = {
  readonly __typename: "StoreZonedDate";
  readonly storeFormattedDate: string;
  readonly " $fragmentType": "WidgetList_listItemInfo";
} | {
  readonly __typename: "WidgetListItemInfoText";
  readonly italic: boolean | null;
  readonly text: string;
  readonly " $fragmentType": "WidgetList_listItemInfo";
} | {
  // This will never be '%other', but we need some
  // value in case none of the concrete values match.
  readonly __typename: "%other";
  readonly " $fragmentType": "WidgetList_listItemInfo";
};
export type WidgetList_listItemInfo$key = {
  readonly " $data"?: WidgetList_listItemInfo$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetList_listItemInfo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetList_listItemInfo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "style",
              "value": "DEFAULT"
            }
          ],
          "kind": "ScalarField",
          "name": "storeFormattedDate",
          "storageKey": "storeFormattedDate(style:\"DEFAULT\")"
        }
      ],
      "type": "StoreZonedDate",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "text",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "italic",
          "storageKey": null
        }
      ],
      "type": "WidgetListItemInfoText",
      "abstractKey": null
    }
  ],
  "type": "WidgetListItemInfo",
  "abstractKey": "__isWidgetListItemInfo"
};

(node as any).hash = "46bfa2fb985aab987c00a741f06afd78";

export default node;
